/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventClassification } from './EventClassification';
import {
    EventClassificationFromJSON,
    EventClassificationFromJSONTyped,
    EventClassificationToJSON,
    EventClassificationToJSONTyped,
} from './EventClassification';

/**
 * A canonical performer, team, or show that events were pinned to.
 * @export
 * @interface EventAttraction
 */
export interface EventAttraction {
    /**
     * 
     * @type {string}
     * @memberof EventAttraction
     */
    attractionId: string;
    /**
     * 
     * @type {string}
     * @memberof EventAttraction
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventAttraction
     */
    url?: string;
    /**
     * 
     * @type {EventClassification}
     * @memberof EventAttraction
     */
    classification?: EventClassification;
}

/**
 * Check if a given object implements the EventAttraction interface.
 */
export function instanceOfEventAttraction(value: object): value is EventAttraction {
    if (!('attractionId' in value) || value['attractionId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function EventAttractionFromJSON(json: any): EventAttraction {
    return EventAttractionFromJSONTyped(json, false);
}

export function EventAttractionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAttraction {
    if (json == null) {
        return json;
    }
    return {
        
        'attractionId': json['attraction_id'],
        'name': json['name'],
        'url': json['url'] == null ? undefined : json['url'],
        'classification': json['classification'] == null ? undefined : EventClassificationFromJSON(json['classification']),
    };
}

export function EventAttractionToJSON(json: any): EventAttraction {
    return EventAttractionToJSONTyped(json, false);
}

export function EventAttractionToJSONTyped(value?: EventAttraction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attraction_id': value['attractionId'],
        'name': value['name'],
        'url': value['url'],
        'classification': EventClassificationToJSON(value['classification']),
    };
}

